var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-b border-border pb-1" },
    [
      _c(
        "div",
        { staticClass: "bg-white header-bottom-mobile pt-1" },
        [
          _c(
            "top",
            {
              attrs: {
                "user-logged-in": _vm.userLoggedIn,
                "cart-qty": _vm.cartQuantity,
                "is-whitelabel": _vm.isWhitelabel,
                cart: _vm.cart
              },
              on: {
                "log-out": function($event) {
                  return _vm.$emit("log-out")
                },
                "open-menu": function($event) {
                  return _vm.$emit("open-menu")
                }
              }
            },
            [_vm._t("default")],
            2
          )
        ],
        1
      ),
      !_vm.isMobileSalesPage
        ? _c("bottom", {
            attrs: {
              "cart-route": _vm.cartRoute,
              "checkout-route": _vm.checkoutRoute,
              cart: _vm.cart,
              search: _vm.search,
              categories: _vm.marketplaceCategories,
              "is-whitelabel": _vm.isWhitelabel
            },
            on: {
              "toggle-shop-menu": _vm.toggleShopMenu,
              "search-input": function($event) {
                return _vm.$emit("search-input", $event)
              },
              "perform-search": function($event) {
                return _vm.$emit("perform-search", $event)
              }
            }
          })
        : _vm._e(),
      _vm.currentScrollTop > 0 && !_vm.isMobileSalesPage
        ? _c(
            "div",
            {
              staticClass:
                "bg-white header-bottom-mobile py-1 fixed top-0 w-full z-103",
              class: {
                "border-b border-border":
                  !_vm.scrollingUp || _vm.hideFixedHeader
              }
            },
            [
              _c(
                "top",
                {
                  attrs: {
                    "user-logged-in": _vm.userLoggedIn,
                    "cart-qty": _vm.cartQuantity,
                    "is-whitelabel": _vm.isWhitelabel,
                    cart: _vm.cart
                  },
                  on: {
                    "log-out": function($event) {
                      return _vm.$emit("log-out")
                    },
                    "open-menu": function($event) {
                      return _vm.$emit("open-menu")
                    }
                  }
                },
                [_vm._t("default")],
                2
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          ref: "headerBottomFixed",
          staticClass:
            "z-102 w-full bg-white fixed transition-all transition-250",
          class: { hidden: _vm.hideFixedHeader || _vm.isMobileSalesPage },
          style: {
            top: "45px",
            height:
              _vm.scrollingUp && !_vm.hideFixedHeader
                ? [_vm.cartRoute, _vm.checkoutRoute].includes(
                    _vm.$route.name
                  ) || _vm.isWhitelabel
                  ? "62px"
                  : "97px"
                : "0"
          }
        },
        [
          _c("bottom", {
            attrs: {
              "cart-route": _vm.cartRoute,
              "checkout-route": _vm.checkoutRoute,
              cart: _vm.cart,
              search: _vm.search,
              categories: _vm.marketplaceCategories,
              "is-whitelabel": _vm.isWhitelabel
            },
            on: {
              "toggle-shop-menu": _vm.toggleShopMenu,
              "search-input": function($event) {
                return _vm.$emit("search-input", $event)
              },
              "perform-search": function($event) {
                return _vm.$emit("perform-search", $event)
              }
            }
          }),
          _c("div", {
            staticClass: "border-b border-border pt-1 h-px",
            class: { hidden: !_vm.scrollingUp }
          })
        ],
        1
      ),
      !_vm.isWhitelabel
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showShopByMenu,
                  expression: "showShopByMenu"
                }
              ],
              staticClass: "fixed top-0 left-0 w-full h-full z-1000"
            },
            [
              _c("div", {
                staticClass: "bg-black opacity-25 h-full w-full",
                on: { click: _vm.toggleShopMenu }
              }),
              _c(
                "div",
                {
                  staticClass:
                    "absolute absolute--center w-3-4 text-white text-center pb-1 h-full"
                },
                [
                  _c("div", { staticClass: "fixed text-right top-0 right-0" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "h-2 inline-block mt-6 mr-1",
                        attrs: { tabindex: "0", viewBox: "0 0 24 24" },
                        on: {
                          click: _vm.toggleShopMenu,
                          keyup: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.toggleShopMenu($event)
                          }
                        }
                      },
                      [
                        _c("path", {
                          staticClass: "fill-current",
                          attrs: {
                            d:
                              "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                          }
                        })
                      ]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "overflow-auto max-h-3-4 rounded bg-brand mt-5 py-1"
                    },
                    _vm._l(_vm.marketplaceCategories, function(category) {
                      return _c(
                        "router-link",
                        {
                          key: category.slug,
                          staticClass: "text-3xl p-_5",
                          attrs: {
                            tabindex: "0",
                            tag: "div",
                            to: {
                              name: "marketplace",
                              query: { category: category.value },
                              params: { page: "1", nav: true }
                            }
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.toggleShopMenu($event)
                            },
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.toggleShopMenu($event)
                            }
                          }
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "transition-250 transition-color hover_text-white cursor-pointer"
                            },
                            [_vm._v(_vm._s(category.text))]
                          )
                        ]
                      )
                    }),
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }